import {
    getByFullFunctionNameKey,
    DynamicallyInstrumentedFunction,
    DynamicallyInstrumentedFunctionState,
} from './DynamicallyInstrumentedFunctionState'
import { FETCH_DYNAMICALLY_INSTRUMENTED_FUNCTIONS, DYNAMICALLY_INSTRUMENT_FUNCTION } from './actions'
import { FULFILLED, PENDING } from '../action-helper'

const initialState: DynamicallyInstrumentedFunctionState = {
    byId: {},
    byFullFunctionName: {},
    loaded: false,
    loading: false,
    error: false,
    errorMessage: '',
}

export const dynamicallyInstrumentedFunctionReducer = (
    state: DynamicallyInstrumentedFunctionState = initialState,
    action: any,
): DynamicallyInstrumentedFunctionState => {
    switch (action.type) {
        case FULFILLED(DYNAMICALLY_INSTRUMENT_FUNCTION): {
            const { payload: data } = action
            const trackedFunction = data.trackedFunction

            const byFullFunctionNameKey = getByFullFunctionNameKey(trackedFunction.className, trackedFunction.functionName)

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [trackedFunction.id]: trackedFunction,
                },
                byFullFunctionName: {
                    ...state.byFullFunctionName,
                    [byFullFunctionNameKey]: trackedFunction.id,
                },
                error: data.error,
            }
        }
        case FULFILLED(FETCH_DYNAMICALLY_INSTRUMENTED_FUNCTIONS): {
            const { payload: data } = action
            const byFullFunctionName = {}
            const trackedFunctions = data.trackedFunctions

            Object.values(trackedFunctions).forEach((trackedFunction: DynamicallyInstrumentedFunction) => {
                const byFullFunctionNameKey = getByFullFunctionNameKey(trackedFunction.className, trackedFunction.functionName)

                byFullFunctionName[byFullFunctionNameKey] = trackedFunction.id
            })

            return {
                ...state,
                byId: { ...data },
                byFullFunctionName: byFullFunctionName,
                loading: false,
                loaded: true,
                error: data.error,
                errorMessage: data.errorMessage,
            }
        }
        case PENDING(FETCH_DYNAMICALLY_INSTRUMENTED_FUNCTIONS): {
            return {
                ...state,
                loading: true,
            }
        }
    }
    return state
}
